import * as React from 'react';
import AssetsManager from '../../../../../../common/utils/AssetsManager';
import {COMMON} from '../../../../../../common/constants/LabelConstants';

class ValidationIdErrorView extends React.Component<{data: {message: string}}, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div className="container text-center">
                            <img
                                className="py-3"
                                src={AssetsManager('/assets/images/common/thin-attention-error.svg')}/>
                            <h5 className="main-title pt-3">{COMMON.ERROR_TITLE}</h5>
                            <p>{this.props.data.message}</p>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ValidationIdErrorView;
